import {
  archive_icon,
  client_portal_icon,
  delete_icon,
  pdf_icon,
  plus_blue_icon,
  settings_blue_icon,
  share_icon,
} from "assets/icons/icons";

const items = [
  {
    key: "1",
    label: (
      <div className="flex items-center pt-2 pr-5">
        <img src={pdf_icon} alt="" className="mr-2" width={20} />
        <p>View Statement</p>
      </div>
    ),
  },
  {
    key: "2",
    label: (
      <div className="flex items-center pt-2 pr-5">
        <img src={client_portal_icon} alt="" className="mr-2" width={20} />
        <p>Client Portal</p>
      </div>
    ),
  },
  {
    key: "3",
    label: (
      <div className="flex items-center pt-2 pr-5 pb-1">
        <img src={settings_blue_icon} alt="" className="mr-2" width={20} />
        <p>Settings</p>
      </div>
    ),
  },
  {
    key: "4",
    label: (
      <div className="flex items-center pt-3 pr-5 border-t-[1px] border-[rgba(0,0,0,.1)]">
        <img src={plus_blue_icon} alt="" className="mr-2" width={20} />
        <p>New Invoice</p>
      </div>
    ),
  },
  {
    key: "5",
    label: (
      <div className="flex items-center pt-2 pr-5">
        <img src={plus_blue_icon} alt="" className="mr-2" width={20} />
        <p>New Quote</p>
      </div>
    ),
  },
  {
    key: "6",
    label: (
      <div className="flex items-center pt-2 pr-5">
        <img src={plus_blue_icon} alt="" className="mr-2" width={20} />
        <p>Enter Payment</p>
      </div>
    ),
  },
  {
    key: "7",
    label: (
      <div className="flex items-center pt-2 pr-5">
        <img src={plus_blue_icon} alt="" className="mr-2" width={20} />
        <p>New Task</p>
      </div>
    ),
  },
  {
    key: "8",
    label: (
      <div className="flex items-center pt-2 pr-5 pb-1">
        <img src={plus_blue_icon} alt="" className="mr-2" width={20} />
        <p>New Expense</p>
      </div>
    ),
  },
  {
    key: "9",
    label: (
      <div className="flex items-center pt-3 pr-5 border-t-[1px] border-[rgba(0,0,0,.1)]">
        <img src={share_icon} alt="" className="mr-2" width={20} />
        <p>Merge</p>
      </div>
    ),
  },
  {
    key: "10",
    label: (
      <div className="flex items-center pt-2 pr-5">
        <img src={archive_icon} alt="" className="mr-2" width={20} />
        <p>Archive</p>
      </div>
    ),
  },
  {
    key: "11",
    label: (
      <div className="flex items-center pt-2 pr-5">
        <img src={delete_icon} alt="" className="mr-2" width={15} />
        <p>Delete</p>
      </div>
    ),
  },
  {
    key: "12",
    label: (
      <div className="flex items-center py-2 pr-5">
        <img src={delete_icon} alt="" className="mr-2" width={15} />
        <p>Purge</p>
      </div>
    ),
  },
];

export default items;
